export var getEventTarget = function getEventTarget(event) {
  if ('composedPath' in event) {
    var _event$composedPath;
    return ((_event$composedPath = event.composedPath()) === null || _event$composedPath === void 0 ? void 0 : _event$composedPath[0]) || event.target;
  }
  if (event.nativeEvent && 'composedPath' in event.nativeEvent) {
    var _event$nativeEvent$co;
    return ((_event$nativeEvent$co = event.nativeEvent.composedPath()) === null || _event$nativeEvent$co === void 0 ? void 0 : _event$nativeEvent$co[0]) || event.target;
  }
  return event.target;
};
//# sourceMappingURL=getEventTarget.mjs.map